<template>
  <div class="card">
    <div class="card-body general-details">
      <h4 class="font-weight-bold d-block mb-4">
        Roles in IFAC
      </h4>
      <ifac-loader class="p-5" v-if="busy"></ifac-loader>
      <div v-else>
        <div class="row my-4 text-center" v-if="!mx_hasPositions && !conferenceRoles.length">
          <div class="col">
            <div class="mb-4">
              <i class="far fa-exclamation fa-4x text-primary"></i>
            </div>
            <p>No roles</p>
          </div>
        </div>
        <div class="row" v-if="mx_hasPositions">
          <div class="col mt-3">
            <p v-for="(position, key) in mx_sortedAffiliatePositions" :key="key">
              {{ mx_getPositionName(position) }}
              <span class="d-block alert alert-light p-2 border" v-if="position.notes">
                <IfacRoleNotes :text="position.notes"/>
              </span>
            </p>
          </div>
        </div>
        <ifac-conference-roles-list
          v-if="conferenceRoles.length"
          class="mt-4"
          :roles="conferenceRoles"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Affiliates from '@/services/Api/Affiliates';
import AffiliatesPublic from '@/services/Api/Public/Affiliates';
import ConferenceRoles from '@/services/Api/ConferenceRoles';
import {
  IfacConferenceRolesList,
  IfacRoleNotes,
  IfacLoader,
  ifacPositionsMixin,
} from '@ifac/ui';

export default {
  components: {
    IfacLoader,
    IfacRoleNotes,
    IfacConferenceRolesList,
  },
  mixins: [ifacPositionsMixin],
  created() {
    this.fetchData();
  },
  data() {
    return {
      busy: false,
      currentPositions: [],
      conferenceRoles: [],
    };
  },
  computed: {
    ...mapState({
      authed: (state) => state.auth.isAuthenticated,
    }),
  },
  methods: {
    async fetchAffiliate() {
      const {
        data: { data },
      } = await Affiliates.show(this.$route.params.id);

      this.currentPositions = data.positions;
    },
    async fetchAffiliatePublic() {
      const {
        data: { data },
      } = await AffiliatesPublic.show(this.$route.params.id);

      this.currentPositions = data.positions;
    },
    async fetchConferenceRoles() {
      try {
        const { status, data } = await ConferenceRoles.show(this.$route.params.id);

        if (status === 200) {
          this.conferenceRoles = data?.data || data || [];
        }
      } catch (e) {
        this.conferenceRoles = [];
      }
    },
    async fetchData() {
      this.busy = true;

      if (this.authed) {
        await this.fetchAffiliate();
      } else {
        await this.fetchAffiliatePublic();
      }

      await this.fetchConferenceRoles();
      this.busy = false;
    },
  },
};
</script>
